<template>
  <v-menu
    v-model="menu2"
    :close-on-content-click="false"
    max-width="290px"
    min-width="auto"
    offset-y
    transition="scale-transition"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        v-model="computedDateFormatted"
        :label="label"
        hint="в формате ДД.ММ.ГГГГ"
        persistent-hint
        prepend-icon="mdi-calendar"
        readonly
        v-bind="attrs"
        v-on="on"
      />
    </template>
    <v-date-picker
      v-model="date"
      :first-day-of-week="1"
      locale="ru-ru"
      no-title
      @input="menu2 = false"
    />
  </v-menu>
</template>
<script>

import { format } from "date-fns-tz"

export default {
  name: "DatePicker",
  model: {
    prop: "isoDate",
    event: "getDate"
  },
  props: ["label", "isoDate"],
  data: vm => ({
    date: null,
    dateFormatted: null,
    menu2: false
  }),
  computed: {
    computedDateFormatted: {
      get: function () {
        return this.formatDate(this.date)
      },
      set: function (value) {
        this.date = value
      }
    }
  },
  watch: {
    date () {
      this.dateFormatted = this.formatDate(this.date)
      // console.log(`watch ${this.date}`)
      this.$emit("getDate", this.date)
    },
    isoDate () {
      // console.log(`this.isoDate=${this.isoDate}`)
      this.computedDateFormatted = this.isoDate
    }
  },
  mounted () {
    // console.log(`this.isoDate=${this.isoDate}`)
    this.computedDateFormatted = this.isoDate
  },
  methods: {
    formatDate (date) {
      if (!date) return null
    // console.log('DatePicker date', date)
      return format(new Date(date), 'dd.MM.yyyy')
    }
  }
}
</script>

<style scoped>

</style>
